import { useEffect, useState } from 'react';
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { Box, IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useUploadHistory } from './CJWManageHistory.hooks';
import CJWManageHistoryTable from '../../shared/CJWManageHistoryTable/CJWManageHistoryTable';
import classes from './CJWManageHistory.module.css';

const CJWManageHistory = () => {
    const [searchParams] = useSearchParams();
    const batchId = searchParams.get("batchId");
    const [mode, setMode] = useState(batchId ? "DI" : "APG_ASG");
    const { uploadHistory, fetchUploadHistory, loading } = useUploadHistory(mode === "DI", batchId);

    useEffect(() => {
        setMode(batchId ? "DI" : "APG_ASG");
    }, [batchId]);

    const handleModeChange = (event, newMode) => {
        if (newMode !== null) {
            setMode(newMode);
        }
    };

    return (
        <div className={classes.body}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Tooltip title="Back to DC flow" describeChild>
                    <IconButton
                        component={RouterLink}
                        to="/dc-cost/approvals"
                        aria-label="Back to DC Flow"
                        size="small"
                    >
                        <ArrowBackIcon />
                    </IconButton>
                </Tooltip>
                <div className={classes.heading}>CJW MANAGE HISTORY</div>
            </Box>
            <div className={classes.fileuploadHistory}>
                <CJWManageHistoryTable
                    uploadHistory={uploadHistory}
                    fetchUploadHistory={fetchUploadHistory}
                    isPaginationRequired={true}
                    loading={loading}
                    isDIMode={mode === "DI"}
                    mode={mode}
                    onModeChange={handleModeChange}
                />
            </div>
        </div>
    )
}

export default CJWManageHistory;
